module.exports = __webpack_public_path__ + "img/ic_gift_giveaway.05db6521.svg";